import React from 'react';
import { ParticipantTile, useTrackContext } from '@livekit/components-react';
import ParticipantStatsOverlay from './ParticipantStatsOverlay';

export default function ParticipantTileWithStats({ showStats = false }) {
  // Use LiveKit's hook to get the current track context
  const trackReference = useTrackContext();
  
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      {/* ParticipantTile doesn't need trackReference as a prop - it uses context */}
      <ParticipantTile />
      
      {/* Only show stats if we have a participant AND showStats is true */}
      {showStats && trackReference?.participant && (
        <ParticipantStatsOverlay participant={trackReference.participant} />
      )}
    </div>
  );
}
